/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCropDtoFromDiscriminatorValue, type CropDto } from '../../../../models/index.js';
// @ts-ignore
import { createODataErrorFromDiscriminatorValue, type ODataError } from '../../../../models/oDataErrors/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Provides operations to manage the crop property of the AapService.GenusDto entity.
 */
export interface WithCropItemRequestBuilder extends BaseRequestBuilder<WithCropItemRequestBuilder> {
    /**
     * Get crop from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CropDto>}
     * @throws {ODataError} error when the service returns a 4XX or 5XX status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCropItemRequestBuilderGetQueryParameters> | undefined) : Promise<CropDto | undefined>;
    /**
     * Get crop from GenusOverview
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCropItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Get crop from GenusOverview
 */
export interface WithCropItemRequestBuilderGetQueryParameters {
    /**
     * Expand related entities
     */
    expand?: string[];
    /**
     * Select properties to be returned
     */
    select?: string[];
}
/**
 * Uri template for the request builder.
 */
export const WithCropItemRequestBuilderUriTemplate = "{+baseurl}/GenusOverview/{genusId}/crop/{cropId}{?%24expand,%24select}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const WithCropItemRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "expand": "%24expand",
    "select": "%24select",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCropItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCropItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            XXX: createODataErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCropDtoFromDiscriminatorValue,
        queryParametersMapper: WithCropItemRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
